/* JB カートドロワーの「近い商品」2点（snippets/jb-cart-related.liquid）
   ドロワーはコレクションの商品で出しておき、ここで Shopify のおすすめ（related）入りに差し替える。
   カートの中身が変わるとドロワー側で入れ替わる（data-merge-cache）ので、そのたびに取り直す。同じ中身の結果は使い回す。 */
(function () {
  if (window.__jbCartRelated) return;
  window.__jbCartRelated = true;

  var cache = {};

  function swap(box, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var result = doc.querySelector('[data-jb-cr-result]');
    if (!result) return;
    var next = result.querySelector('.jb-cr');
    // 空のとき・カートの中身が食い違うときはコレクションの商品のまま
    if (!next || next.getAttribute('data-jb-cr-key') !== box.getAttribute('data-jb-cr-key')) return;
    next.setAttribute('data-jb-cr-done', '');
    box.replaceWith(document.importNode(next, true));
  }

  function load() {
    var box = document.querySelector('.jb-cr[data-jb-cr]:not([data-jb-cr-done])');
    if (!box) return;
    var key = box.getAttribute('data-jb-cr-key');
    box.setAttribute('data-jb-cr-done', '');
    if (cache[key]) { swap(box, cache[key]); return; }
    fetch(box.getAttribute('data-jb-cr'))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        cache[key] = html;
        if (box.isConnected) swap(box, html);
      })
      .catch(function () { /* 取得できなければコレクションの商品のまま */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
  document.addEventListener('on:cart:after-merge', load);
})();
